// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1pRlW","info":"UpdateTermsInfo_info__2IE9g"};